import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {StockDataSource} from '@app/stock/shared/stock.datasource';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {StockApi} from '@app/stock/shared/stock.api';
import {merge} from 'rxjs';
import {debounceTime, tap} from 'rxjs/operators';
import {Vehicle} from '@app/vehicle/shared/vehicle';
import {MatPaginator} from '@angular/material/paginator';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {pageSizeOptions, Pagination} from "@shared/base";
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { DatePipe } from '@angular/common';

@Component({
    templateUrl: 'search-car-dialog.component.html',
    styleUrls: ['search-car-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, MatIconButton, MatTooltip, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class SearchCarDialogComponent implements OnInit, AfterViewInit {
  private stockApi = inject(StockApi);
  dialogRef = inject<MatDialogRef<SearchCarDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  filterForm: UntypedFormGroup;
  dataSource: StockDataSource;
  displayedColumns = ['vehicle.vrn', 'vehicle.brand', 'vehicle.model', 'vehicle.type', 'vehicle.color',
    'vehicle.firstAdmissionDate', 'actions'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor() {

    this.createForm();

    this.filterForm.valueChanges
      .pipe(debounceTime(300))
      .subscribe(() => {
        this.loadData();
      });
  }

  ngOnInit(): void {
    this.dataSource = new StockDataSource(this.stockApi);
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 12;
    this.sort.active = 'vehicle.brand,vehicle.model,vehicle.type,vehilce.vrn';
    this.sort.direction = 'asc';

    this.loadData();
  }

  ngAfterViewInit() {
    merge(this.sort.sortChange, this.paginator.page).pipe(
      tap(() => this.loadData())
    ).subscribe();
  }

  createForm() {
    this.filterForm = new UntypedFormGroup({
      'vehicle.brand': new UntypedFormControl()
    });
  }

  loadData() {
    const pagination = new Pagination(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction);
    this.dataSource.loadStock(this.filterForm.value, pagination);
  }

  select(vehicle: Vehicle) {
    this.dialogRef.close(vehicle);
  }

  close() {
    this.dialogRef.close(false);
  }

  protected readonly pageSizeOptions = pageSizeOptions;
}
